import Colors from 'constants/Colors';


export default {
  editorContainer: {
    display: 'flex',
    gap: 32,
    flexDirection: 'column',
  },

  contentWrapper: {
    padding: '2rem',

    borderRadius: '1rem',
  },

  infoText: {
    marginBottom: '2rem',
    color: Colors.darkText
  },

  checkboxContainer: {
    border: '1px solid #000',
    borderRadius: '1rem',
    padding: '1.5rem',
    backgroundColor: '#fff',
    marginBottom: '2rem',
  },

  checkboxItem: {
    marginBottom: '1rem',
    color: Colors.darkText
  },

  checkboxLabel: {
    marginLeft: '0.5rem',
    fontWeight: 'normal',
  },

  viewLink: {
    fontWeight: 'bold',
  },

  disabledButton: {
    backgroundColor: '#ccc',
    color: '#fff',
    textAlign: 'center',
    borderRadius: '2rem',
    padding: '1rem',
    fontWeight: 'bold',
    cursor: 'not-allowed',
  },

  sectionBox: {
    border: '1px solid #000',
    borderRadius: '1rem',
    padding: '1rem 1.5rem',
    backgroundColor: '#fff',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '1rem',
    color: Colors.darkText

  },

  sectionButton: {
    backgroundColor: '#f3f7ff',
    color: '#0040a0',
    padding: '0.5rem 1rem',
    borderRadius: '1rem',
    border: 'none',
    fontWeight: 'bold',
    cursor: 'pointer',
    
  },

  signatureContainer: {
    border: '1px solid #000',
    borderRadius: '1rem',
    padding: '1.5rem',
    backgroundColor: '#fff',
    marginBottom: '2rem',
  },

  signatureLabel: {
    display: 'block',
    marginBottom: '0.5rem',
    color: Colors.darkText
  },

  signatureBox: {
    backgroundColor: '#f0f6ff',
    height: '150px',
    borderRadius: '1rem',
    position: 'relative',
  },

  layoutWrapper: {
    display: 'flex',
    gap: '2rem',
    width: '100%',
    alignItems: 'flex-start',
    boxSizing: 'border-box',
},

column: {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: '2rem',
  boxSizing: 'border-box',
},
checkinFields:{
  border: '1px solid #000',
    borderRadius: '1rem',
    padding: '1.5rem',
    backgroundColor: '#fff',
    marginBottom: '2rem'
},
};
